import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home/Home'
import Book from '@/pages/Book/Book'
import Detail from '@/pages/Detail/Detail'
import Entry from '@/pages/Entry/Entry'
import SearchItem from '@/pages/SearchItem/SearchItem'

Vue.use(Router)

const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const router =  new Router({
  mode: 'history',
  base: 'edu',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/book',
      name: 'Book',
      component: Book
    },
    {
      path: '/detail',
      name: 'Detail',
      component: Detail
    },
    {
      path: '/entry',
      name: 'Entry',
      component: Entry
    },
    {
      path: '/searchitem',
      name: 'SearchItem',
      component: SearchItem
    }
  ]
})
//后置守卫
let first = true
router.afterEach((to) => {
  if (window._paq) {
    if (first) {
      // 第一次进来（刷新），index.html 已经自动 track 过一次，我们跳过
      first = false
    } else {
      // 后续路由切换再手动补一次
      window._paq.push(['setCustomUrl', to.fullPath])
      window._paq.push(['trackPageView'])
    }
  }
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js